export default __webpack_public_path__ + "static/media/group5567.039af278.svg";